import { render, staticRenderFns } from "./ItemDiscountList.vue?vue&type=template&id=dd6a4d78&scoped=true&"
import script from "./ItemDiscountList.vue?vue&type=script&lang=js&"
export * from "./ItemDiscountList.vue?vue&type=script&lang=js&"
import style0 from "./ItemDiscountList.vue?vue&type=style&index=0&id=dd6a4d78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6a4d78",
  null
  
)

export default component.exports